import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import { BasePreviewSlot, BasePreviewWrapper } from "../../base";

function FormDOBPreview({ ...props }) {
  return <BasePreviewWrapper>
    <div className="grid grid-cols-3 gap-2">
      <BasePreviewSlot {...props}>
        <select>
          <option value="">Month</option>
          <option value="jan">January</option>
          <option value="feb">February</option>
          <option value="mar">March</option>
          <option value="apr">April</option>
          <option value="may">May</option>
          <option value="jun">June</option>
          <option value="jul">July</option>
          <option value="aug">August</option>
        </select>
      </BasePreviewSlot>
      <BasePreviewSlot {...props}>
        <select>
          <option value="">Day</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
        </select>
      </BasePreviewSlot>
      <BasePreviewSlot {...props}>
        <select>
          <option value="">Year</option>
          <option value="2025">2025</option>
          <option value="2024">2024</option>
        </select>
      </BasePreviewSlot>
    </div>
  </BasePreviewWrapper>
}

export default define('form-dob', FormDOBPreview, Fragment)
  .shared(prop.share('FormDOB', 'form-dob'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    space: {
      padding: 'pt-1 pb-1 pl-2 pr-2',
    },
    border: {
      radius: {
        rounded: "sm",
      },
      width: {
        border: "1",
      },
      color: "gray-400",
    },
    size: {
      width: "w-full",
      height: "min-h-8",
    },
  })
  .build()

